export interface ReleaseLog {
  version: string
  releaseDate: string
  title: string
  changes: string[]
}

export interface ReleaseInfo {
  version: string
  logs: ReleaseLog[]
}

// 2026-09-05：登录页和版本日志展示本次构建版本，后端独立升级或接口异常均不能覆盖。
export const DEFAULT_RELEASE_VERSION = process.env.VUE_APP_PROJECT_VERSION as string

export const createDefaultReleaseInfo = (): ReleaseInfo => ({
  version: DEFAULT_RELEASE_VERSION,
  logs: [
    {
      // 2026-09-05：已有历史日志保留原始发布版本，不能随当前项目版本递增。
      version: '4.0.1',
      releaseDate: '2026-07-30',
      title: '管理和交易体验优化',
      changes: [
        '操作日志新增人员搜索和仅登录记录筛选。',
        '修复纸质版打印发货长时间加载及重复发货问题。',
        '平台超级管理员可通过短信验证设置 C 端超级密码。',
        '管理端新增版本日志入口，登录页和客户端首页新增版本号。',
        '微信支付订单新增可配置的电子发票入口能力。'
      ]
    }
  ]
})

const normalizeVersion = (version: unknown): string => {
  if (typeof version !== 'string') {
    return DEFAULT_RELEASE_VERSION
  }
  const normalized = version.trim().replace(/^v/i, '')
  return normalized || DEFAULT_RELEASE_VERSION
}

export const normalizeReleaseInfo = (data: any): ReleaseInfo => {
  const defaultInfo = createDefaultReleaseInfo()
  if (!data || typeof data !== 'object') {
    return defaultInfo
  }
  return {
    version: DEFAULT_RELEASE_VERSION,
    logs: Array.isArray(data.logs) && data.logs.length > 0
      ? data.logs.map((item: any) => ({
        version: normalizeVersion(item.version),
        releaseDate: typeof item.releaseDate === 'string' ? item.releaseDate : '',
        title: typeof item.title === 'string' ? item.title : '',
        changes: Array.isArray(item.changes) ? item.changes : []
      }))
      : defaultInfo.logs
  }
}
